<template>
	<!-- 监理月报 -->
	<div class="mod-config">
		<el-card body-style="padding-bottom: 0;" style="margin-top: -5px;">
			<div class="title">监理月报</div>
			<div class="line"></div>
			<el-row style="margin-bottom: 5px;">
				<el-col :span="pageSpan">
					<el-button v-preventReClick class="btn" type="primary" size="small" @click="addOrUpdateHandle()"
						v-if="showAdd">创建</el-button>
					<!-- <el-button v-preventReClick class="btn" type="primary" size="small"
						@click="monthlyReportUpload()">上传</el-button> -->
				</el-col>
			</el-row>
		</el-card>
		<div>
			<el-card style="margin-top: -3px;" body-style=" padding: 0;">
				<el-row style="margin-bottom: 10px;">
					<el-col :span="24">
						<div class="box">
							<el-table :height="screenHeight - 206 + 'px'" :row-class-name="tableRowClassName"
								class="dataListTable" border :data="dataList" header-align="center"
								style="width: 100%;margin-bottom: 20px;" header-cell-class-name="dataListTHeader"
								:cell-style="{ padding: '0px' }">
								<el-table-column type="index" label="NO." width="60" align="center">
									<template slot-scope="scope">{{ (pageIndex2 - 1) * pageSize + scope.$index + 1
									}}</template>
								</el-table-column>
								<el-table-column prop="monthlyName" label="月报名称" min-width="180" align="center">
									<template slot-scope="scope">
										<el-button v-preventReClick type="text" size="small"
											@click="viewPdf(scope.row.filePath, scope.row.filePathUri, scope.row.monthlyName)">{{
												scope.row.monthlyName }}</el-button>
									</template>
								</el-table-column>
								<el-table-column prop="monthlyTerm" label="期数" width="85" align="center">
								</el-table-column>
								<el-table-column label="日期" min-width="200" align="center">
									<template slot-scope="scope">
										{{ scope.row.beginTime }} 至 {{ scope.row.endTime }}
									</template>
								</el-table-column>
								<!-- <el-table-column prop="beginTime" label="开始时间" align="center" min-width="160">
								</el-table-column>
								<el-table-column prop="endTime" label="结束时间" align="center" min-width="160">
								</el-table-column> -->
								<!-- <el-table-column prop="insDate" label="制作日期" width="100" align="center">
								</el-table-column> -->
								<!-- <el-table-column prop="monthlyKindName" label="形式 " min-width="160" align="center">
								</el-table-column> -->
								<!-- <el-table-column label="确认状态" width="90" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.refirmFlg === '1'">已确认</span>
										<span v-else>未确认</span>
									</template>
								</el-table-column> -->
								<el-table-column prop="refirmMan" label="确认人" width="110" align="center">
								</el-table-column>
								<el-table-column prop="refirmTime" label="确认时间" width="110" align="center">
								</el-table-column>
								<!-- <el-table-column label="操作" min-width="220" fixed="right"
									v-if="showDelete || showEdit || showRowDownload" align="left">
									<template slot-scope="scope">
										<el-button v-preventReClick type="text" size="small"
											@click="editHandle(scope.row.recNo, scope.row.monthlyStatus)"
											v-if="showEdit && scope.row.refirmFlg != '1'">修改</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="createHandle(scope.row.recNo)"
											v-if="scope.row.monthlyStatus === '1' && scope.row.refirmFlg !== '1'">生成</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="fileUploadHandle(scope.row.recNo)"
											v-if="scope.row.refirmFlg !== '1'">上传</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="refirmHandle(scope.row.recNo)"
											v-if="scope.row.showRefirm === '1'">确认</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="cancelRefirmHandle(scope.row.recNo)"
											v-if="scope.row.refirmFlg === '1'">解除确认</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="downloadHandle(scope.row.recNo)"
											v-if="showRowDownload">下载</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="zipDownLoadWeekly(scope.row)"
											v-if="showRowDownload">打包下载</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="deleteHandle(scope.row.recNo)"
											v-if="showDelete && scope.row.refirmFlg != '1'">删除</el-button>
									</template>
								</el-table-column> -->
								<el-table-column label="编辑版" width="220" fixed="right"
									v-if="showDelete || showEdit || showCheck || showRowDownload" align="center">
									<template slot-scope="scope">
										<!-- <el-button v-preventReClick type="text" size="small"
											@click="viewPdf(scope.row.filePath, scope.row.filePathUri, scope.row.monthlyName)">查看</el-button> -->
										<el-button v-preventReClick type="text" size="small"
											v-if="scope.row.refirmFlg != '1'"
											@click="editHandle(scope.row.recNo)">编辑</el-button>
										<!-- <el-button v-preventReClick type="text" size="small"
											@click="createHandle(scope.row.recNo)">
											生成</el-button> -->
										<el-button v-preventReClick type="text" size="small"
											@click="createHandle(scope.row.recNo)"
											v-if="(scope.row.monthlyStatus === '1' || !scope.row.monthlyStatus) && scope.row.refirmFlg !== '1'">
											生成</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="downloadHandle(scope.row.recNo)"
											v-if="showRowDownload">下载</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="zipDownLoadWeekly(scope.row)"
											v-if="showRowDownload">打包下载</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="deleteHandle(scope.row.recNo)"
											v-if="showDelete && scope.row.refirmFlg != '1'">删除</el-button>
									</template>
								</el-table-column>
								<el-table-column label="线下版" width="110" fixed="right" align="center">
									<template slot-scope="scope">
										<el-button v-preventReClick type="text" size="small"
											v-if="scope.row.refirmFlg != '1'"
											@click="uploadOfflineFileHandle(scope.row.recNo)">上传</el-button>
										<!-- <el-button v-preventReClick type="text" size="small"
											v-if="scope.row.offlineFilePath != undefined && scope.row.offlineFilePath != ''"
											@click="viewPdf(scope.row.offlineFilePath, scope.row.offlineFilePathUri, scope.row.monthlyName)">查看</el-button> -->
										<el-button v-preventReClick type="text" size="small"
											v-if="scope.row.offlineFilePath != undefined && scope.row.offlineFilePath != ''"
											@click="offlineFileDownloadHandle(scope.row.recNo)">查看</el-button>
									</template>
								</el-table-column>
								<el-table-column label="状态" width="80" fixed="right" align="center">
									<template slot-scope="scope">
										{{ getStatusLabel(scope.row.refirmFlg) }}
									</template>
								</el-table-column>
								<el-table-column label="审核" width="65" fixed="right" align="center">
									<template slot-scope="scope">
										<el-button v-preventReClick type="text" size="small"
											@click="refirmHandle(scope.row.recNo, scope.row.refirmMan, scope.row.refirmTime)"
											v-if="scope.row.refirmFlg === '' || scope.row.refirmFlg == undefined || scope.row.refirmFlg == '0'">确认</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="cancelRefirmHandle(scope.row.recNo)"
											v-if="scope.row.refirmFlg === '1'">取消</el-button>
									</template>
								</el-table-column>
								<el-table-column label="" width="100" fixed="right" align="left">
									<template slot-scope="scope">
										<el-button v-preventReClick type="text" size="small"
											@click="addProjectHandOver(scope.row)"
											v-if="scope.row.refirmFlg === '1' && scope.row.offlineFilePath != undefined && scope.row.offlineFilePath != ''">
											加入交接清单</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<el-pagination class="my-pagination" @size-change="sizeChangeHandle"
							@current-change="currentChangeHandle" :current-page="pageIndex"
							:page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
							layout="total, sizes, prev, pager, next, jumper">
						</el-pagination>
					</el-col>
				</el-row>
			</el-card>
		</div>

		<!-- <el-dialog title="线下版文件上传" :visible.sync="uploadOfflineFileVisible" width="30%" :close-on-click-modal="false">
			<el-form>
				<el-row>
					<el-col :span="6">
						<div class="item">
							线下版文件
						</div>
					</el-col>
					<el-col :span="14">
						<el-upload v-if="!uploadOfflineFile.uploadOfflineFilePath" ref="uploadMonthlyOfflineFile"
							class="upload-demo" action="action" drag :http-request="uploadMonthlyOfflineFile"
							:show-file-list=false :auto-upload="true" style="margin-left: 10px;">
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						</el-upload>
						<div v-if="uploadOfflineFile.uploadOfflineFilePath" style="margin-left: 10px;">
							<el-button v-preventReClick type="success" size="small" @click="downloadFile(
								uploadOfflineFile.uploadOfflineFileUri, uploadOfflineFile.uploadOfflineFileName)">查看</el-button>
							<el-button v-preventReClick type="primary" size="small"
								@click="delOfflineFile()">删除</el-button>
						</div>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button v-preventReClick class="btn" type="primary" size="small"
					@click="updateOfflineFile()">保存</el-button>
				<el-button v-preventReClick class="rebtn" size="small" @click="uploadOfflineFileVisible = false">取
					消</el-button>
			</span>
		</el-dialog> -->

		<el-dialog title="编辑" :visible.sync="refreshVisible" width="520px" :close-on-click-modal="false">
			<el-row style="font-size: small;margin: 5px 0 10px 0;color: black;">
				<el-col :span="24">
					<span>
						保留汇总数据进行编辑：原有表格数据保持不变；
					</span>
				</el-col>
				<el-col :span="24" style="margin-top: 5px;">
					<span>
						以最新汇总数据进行编辑：同步更新表格数据，需重新生成月报文档。
					</span>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" style="text-align: center;">
					<el-button v-preventReClick type="primary" size="small"
						@click="retainHandle()">保留汇总数据进行编辑</el-button>
					<el-button v-preventReClick type="success" size="small"
						@click="refreshHandle()">以最新汇总数据进行编辑</el-button>
				</el-col>
			</el-row>
		</el-dialog>

		<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
		<monthly-report-upload v-if="reportUploadVisible" ref="weeklyReportUpload"
			@refreshDataList="getDataList"></monthly-report-upload>
		<monthly-export v-if="exportVisible" ref="monthlyExport" @refreshDataList="getDataList"></monthly-export>
		<audit v-if="auditVisible" ref="audit" @refreshDataList="getDataList"></audit>
		<enclosure-add-or-update v-if="enclosureVisible" ref="enclosureAddOrUpdate"
			@refreshDataList="getDataList"></enclosure-add-or-update>
		<monthly-report-file-upload v-if="reportFileUploadVisible" ref="mothlyReportFileUpload"
			@refreshDataList="getDataList"></monthly-report-file-upload>
		<monthly-report-download v-if="downloadVisible" ref="monthlyReportDownload"
			@refreshDataList="getDataList"></monthly-report-download>
		<monthly-refirm v-if="refirmVisible" ref="monthlyRefirm" @refreshDataList="getDataList"></monthly-refirm>
		<monthly-offline-download v-if="monthlyOfflineDownloadVisible" ref="monthlyOfflineDownload"
			@refreshDataList="getDataList"></monthly-offline-download>
		<monthly-offline-upload v-if="monthlyOfflineUploadVisible" ref="monthlyOfflineUpload"
			@refreshDataList="getDataList"></monthly-offline-upload>
		<view-pdf v-if="viewPdfVisible" ref="viewPdf" @refreshDataList="dataList"></view-pdf>
	</div>
</template>
<script>
import AddOrUpdate from './monthly-add-or-update'
import $common from "@/utils/common.js"
import MonthlyExport from './monthly-export'
import EnclosureAddOrUpdate from './enclosure-list'
import MonthlyReportUpload from "./monthly-report-upload.vue"
import MonthlyReportFileUpload from "./monthly-report-file-upload.vue"
import MonthlyReportDownload from "./monthly-report-download.vue"
import audit from './monthly-audit'
import MonthlyRefirm from "./monthly_refirm.vue"
import ViewPdf from "../projectInfo/viewPdf.vue"
import MonthlyOfflineDownload from "./monthly-offline-download.vue"
import MonthlyOfflineUpload from "./monthly-offline-upload.vue"
export default {
	data() {
		return {
			viewPdfVisible: false,
			refreshVisible: false,
			refirmVisible: false,
			showSearch: false,
			showDownload: false,
			showAdd: false,
			showEdit: false,
			showDelete: false,
			showCheck: false,
			showArchive: false,
			showCreateFile: false,
			showRowDownload: false,
			pageSpan: 12,
			tabIndex: "0",
			addOrUpdateVisible: false,
			fileUploadVisible: false,
			exportVisible: false,
			auditVisible: false,
			enclosureVisible: false,
			reportUploadVisible: false,
			reportFileUploadVisible: false,
			monthlyOfflineDownloadVisible: false,
			monthlyOfflineUploadVisible: false,
			downloadVisible: false,
			form: {},
			checked: "",
			dataList: [],
			tableSelVal: [],
			//当前页码
			pageIndex: 1,
			// 显示序号
			pageIndex2: 1,
			//当前记录数
			pageSize: 20,
			//总页数
			totalPage: 0,
			screenHeight: 0,
			uploadRecNo: '',
			uploadOfflineFileName: '',
			uploadOfflineFileVisible: false,
			uploadOfflineFile: {
				uploadOfflineFilePath: '',
				uploadOfflineFileUri: '',
				uploadOfflineFileName: ''
			},
			editRecNo: '',
		};
	},
	components: {
		AddOrUpdate,
		audit,
		MonthlyExport,
		EnclosureAddOrUpdate,
		MonthlyReportUpload,
		MonthlyReportFileUpload,
		MonthlyReportDownload,
		MonthlyRefirm,
		ViewPdf,
		MonthlyOfflineDownload,
		MonthlyOfflineUpload
	},
	mounted() {
		this.screenHeight = window.innerHeight
		this.showSearch = $common.isAuth('monthly:search');
		this.showDownload = $common.isAuth('monthly:download');
		this.showAdd = $common.isAuth('monthly:add');
		this.showEdit = $common.isAuth('monthly:edit');
		this.showDelete = $common.isAuth('monthly:delete');
		this.showCheck = $common.isAuth('monthly:check');
		this.showArchive = $common.isAuth('monthly:archive');
		this.showCreateFile = $common.isAuth('monthly:createFile');
		this.showRowDownload = $common.isAuth('monthly:download');
		if (!this.showSearch && !this.showDownload && !this.showAdd) {
			this.pageSpan = 24;
		}
		this.getDataList();
	},
	methods: {
		viewPdf(filePath, fileUri, filename) {
			if (filePath == null || filePath == undefined || filePath == '') {
				this.$message.error("没有可预览的文件！");
				return;
			}
			// pdf和doc文件，需要pdf在线预览，其他类型文件直接下载
			let suffixType = fileUri.substr(fileUri.lastIndexOf(".") + 1)
			if (suffixType != '' && (suffixType === 'pdf' || suffixType === 'doc' || suffixType === 'docx')) {
				// $common.viewFile(filePath)
				this.viewPdfVisible = true;
				this.$nextTick(() => {
					this.$refs.viewPdf.init(filename, filePath)
				})
			} else {
				filename = this.getSuffix(fileUri, filename)
				this.getBlob(fileUri, (blob) => {
					this.saveAs(blob, filename)
				})
			}
		},
		getStatusLabel(refirmFlg) {
			if (refirmFlg == '0' || refirmFlg == null || refirmFlg == '') {
				return '编辑中';
			}
			return '已审核';
		},
		//重置
		resetFormData() {
			this.pageIndex = 1;
			this.getDataList();
		},
		createHandle(id) {
			this.$confirm(`确定对选中的数据进行生成月报吗?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/monthlyreportinfo/downloadMonthly?recNo=" + id,
					method: "POST",
					data: {},
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					}
				});
			})
		},
		archiveFile(id) {
			this.$confirm(`确定对选中的发文进行归档操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/monthlyreportinfo/archiveFile/" + id,
					method: "get",
					data: id,
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					} else {
						this.$message.error("归档设置失败")
					}
				});
			});
		},
		removeArchiveFile(id) {
			this.$confirm(`确定对选中的发文进行取消归档操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/monthlyreportinfo/removeArchiveFile/" + id,
					method: "get",
					data: id,
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					} else {
						this.$message.error("取消归档失败")
					}
				});
			});
		},
		editHandle(id, monthlyStatus) {
			// 周报状态为初始化，不进行数据刷新
			// if (monthlyStatus === "0") {
			// 	this.refreshEnclosureFiles(id)
			// } else {
			// this.refreshAllDataList(id)
			// }
			// 弹窗
			this.editRecNo = id;
			this.refreshVisible = true;
		},
		retainHandle() {
			this.$router.push({ name: 'monthlyExportInfo', query: { recNo: this.editRecNo } });
		},
		refreshHandle() {
			this.refreshAllDataList(this.editRecNo)
		},
		refreshEnclosureFiles(id) {
			let _url = "/business/monthlyreportinfo/refreshEnclosureFiles/" + id;
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: []
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					// 跳转
					this.$router.push({ name: 'monthlyExportInfo', query: { recNo: id } });
				}
			});
		},
		refreshAllDataList(id) {
			let _url = "/business/monthlyreportinfo/refreshAllDataList/" + id;
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: []
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					// 跳转
					this.$router.push({ name: 'monthlyExportInfo', query: { recNo: id } });
				}
			});
		},
		//删除
		deleteHandle(id) {
			this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/monthlyreportinfo/delete/" + id,
					method: "get",
					data: {},
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					} else {
						this.$message.error(data.msg)
					}
				});
			})
		},
		// 获取数据列表
		getDataList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/monthlyreportinfo/list",
				method: 'get',
				params: this.$http.adornParams({
					page: this.pageIndex,
					limit: this.pageSize,
					subjectNo: $common.getItem("subjectNo"),
					workNo: $common.getItem("workNo")
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataList = data.body.records;
					this.totalPage = data.body.totalCount;
					this.pageIndex2 = this.pageIndex
				} else {
					this.dataList = []
					this.totalPage = 0
					this.pageIndex2 = 1
				}
			})
		},
		uploadOfflineFileHandle(id) {
			this.monthlyOfflineUploadVisible = true
			this.$nextTick(() => {
				this.$refs.monthlyOfflineUpload.init(id)
			})
		},
		offlineFileDownloadHandle(id) {
			this.monthlyOfflineDownloadVisible = true
			this.$nextTick(() => {
				this.$refs.monthlyOfflineDownload.init(id)
			})
		},
		// 审核
		auditeHandle(id) {
			this.auditVisible = true
			this.$nextTick(() => {
				this.$refs.audit.init(id)
			})
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val
			this.pageIndex = 1
			this.getDataList()
		},
		// 当前页
		currentChangeHandle(val) {
			this.pageIndex = val
			this.getDataList()
		},
		siteContentViewHeight() {
			var height = this.$store.state.common.documentClientHeight - 160;
			return { height: height + 'px' }
		},
		handleSelectionChange(val) {
			this.tableSelVal = val;
		},
		tableRowClassName({ row, rowIndex }) {
			let color = ''
			for (let item of this.tableSelVal) {
				if (item.id === row.id) color = 'table-SelectedRow-bgcolor'
			}
			return color
		},
		addOrUpdateHandle(id) {
			this.addOrUpdateVisible = true
			this.$nextTick(() => {
				this.$refs.addOrUpdate.init(id)
			})
		},
		monthlyReportUpload() {
			this.reportUploadVisible = true;
			this.$nextTick(() => {
				this.$refs.weeklyReportUpload.init()
			})
		},
		fileUploadHandle(id) {
			this.reportFileUploadVisible = true
			this.$nextTick(() => {
				this.$refs.mothlyReportFileUpload.init(id)
			})
		},
		refirmHandle(id) {
			this.refirmVisible = true
			this.$nextTick(() => {
				this.$refs.monthlyRefirm.init(id)
			})
		},
		cancelRefirmHandle(id) {
			this.$confirm(`确定对选中的数据进行解除确认操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/monthlyreportinfo/cancelMonthlyRefirm/" + id,
					method: "post",
					data: {},
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					}
				});
			})
		},
		downloadHandle(id) {
			this.downloadVisible = true;
			this.$nextTick(() => {
				this.$refs.monthlyReportDownload.init(id)
			})
		},
		// 打包下载
		zipDownLoadWeekly(item) {
			var fileName = item.fileName + ".zip";
			this.$http({
				url: this.$store.state.httpUrl + "/business/monthlyreportinfo/zipDownLoadMonthly?recNo=" + item.recNo,
				method: "POST",
				data: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.global.downLoadFile(data.body, fileName);
						}
					})
				}
			});
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
		// uploadOfflineFileHandle(row) {
		// 	this.uploadRecNo = row.recNo
		// 	this.uploadOfflineFileName = row.monthlyName
		// 	this.uploadOfflineFile = {
		// 		uploadOfflineFilePath: row.offlineFilePath,
		// 		uploadOfflineFileUri: row.offlineFilePathUri,
		// 		uploadOfflineFileName: row.monthlyName
		// 	}
		// 	this.uploadOfflineFileVisible = true
		// },
		// uploadMonthlyOfflineFile(param) {
		// 	const formData = new FormData();
		// 	formData.append('file', param.file);
		// 	this.$refs.uploadMonthlyOfflineFile.clearFiles();
		// 	this.$http.post(
		// 		this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/88/0",
		// 		formData,
		// 		{
		// 			headers: { 'Content-Type': 'multipart/form-data' }
		// 		},
		// 	).then(res => {
		// 		res = res.data;
		// 		if (res.resultCode === 200) {
		// 			this.uploadOfflineFile = {
		// 				uploadOfflineFilePath: res.body.fileSavePath,
		// 				uploadOfflineFileUri: res.body.fileUri,
		// 				uploadOfflineFileName: this.uploadFileName
		// 			}
		// 		} else {
		// 			this.$message.info('文件上传失败')
		// 		}
		// 	})
		// },
		// delOfflineFile() {
		// 	this.uploadOfflineFile = {
		// 		uploadOfflineFilePath: '',
		// 		uploadOfflineFileUri: '',
		// 	}
		// },
		// updateOfflineFile() {
		// 	this.$http({
		// 		url: this.$store.state.httpUrl + "/business/monthlyreportinfo/uploadOfflineFile",
		// 		method: 'post',
		// 		params: this.$http.adornParams({
		// 			recNo: this.uploadRecNo,
		// 			offlineFilePath: this.uploadOfflineFile.uploadOfflineFilePath,
		// 		})
		// 	}).then(({ data }) => {
		// 		if (data && data.resultCode === 200) {
		// 			this.$message({
		// 				message: '操作成功',
		// 				type: 'success',
		// 				duration: 1500,
		// 				onClose: () => {
		// 					this.uploadOfflineFileVisible = false;
		// 					this.uploadOfflineFile = {
		// 						uploadOfflineFilePath: '',
		// 						uploadOfflineFileUri: '',
		// 						uploadOfflineFileName: ''
		// 					}
		// 					this.getDataList()
		// 				}
		// 			})
		// 		}
		// 	})
		// },
		addProjectHandOver(item) {
			const _url = "/business/projecthandoverlist/save";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					workNo: $common.getItem("workNo"),
					fileName: item.monthlyName,
					templatePath: item.offlineFilePath
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
				} else {
					this.$message.error(data.msg);
				}
			});
		},
	}
};
</script>
<style lang="scss" scoped="scoped">
.selItemText {
	font-size: 14px;
	color: #1c1c1c;
	display: inline-block;
	width: 80px;
}

.my-pagination {
	margin-right: 20px !important;
}

// 设置表头样式
::v-deep(.el-table th.el-table__cell) {
	// background-color: #d3e2f4 !important;
	font-size: 15px;
	padding: 2px 0;
}

// 设置表头样式
::v-deep(.el-table th.el-table__cell) {
	font-size: 15px;
	padding: 2px 0;
}

::v-deep(.upload-demo .el-upload-dragger) {
	width: 200px;
	height: 80px;
}

::v-deep(.upload-demo .el-upload-dragger .el-icon-upload) {
	font-size: 30px;
	margin: 12px 1px;
	line-height: 20px;
}

::v-deep(.upload-demo .el-upload-dragger .el-upload__text) {
	line-height: 5px;
}
</style>
